import { render } from "./TronLinkWalletImport.vue?vue&type=template&id=5786fd61&scoped=true"
import script from "./TronLinkWalletImport.vue?vue&type=script&lang=js"
export * from "./TronLinkWalletImport.vue?vue&type=script&lang=js"

import "./TronLinkWalletImport.vue?vue&type=style&index=0&id=5786fd61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5786fd61"]])

export default __exports__